<template>
  <div class="table-support pa-5">
    <v-simple-table class="px-5 pb-5" height="700px">
      <thead>
        <tr>
          <th class="text-left">STT</th>
          <th class="text-left">ID quảng cáo</th>
          <th class="text-left">ID nội dung</th>
          <th class="text-left">ID người gửi</th>
          <th class="text-left">Tên người gửi</th>
          <th class="text-left">ID trang</th>
          <th class="text-left">Tên trang</th>
          <th class="text-left time">Ngày tạo</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in requestList" :key="index">
        <tr>
          <td class="text-left">{{ index + 1 + (currentPage - 1) * limit }}</td>
          <td class="text-left">{{ item.ad_id || "_" }}</td>
          <td class="text-left">{{ item.content_id || "_" }}</td>
          <td class="text-left">{{ item.sender.id || "_" }}</td>
          <td class="text-left">{{ item.sender_name || "_" }}</td>
          <td class="text-left">{{ item.page_id || "_" }}</td>
          <td class="text-left">{{ item.page_name || "_" }}</td>
          <td class="text-left">{{ formatDate(item.createdAt) || "_" }}</td>
     
        </tr>
      </tbody>
      <tbody v-if="requestList.length <= 0">
        <tr>
          <td colspan="100">
            <common-no-result />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="pb-3">
      <!--            <v-pagination-->
      <!--                v-if="totalItem > limit"-->
      <!--                v-model="currentPage"-->
      <!--                class="justify-sm-end"-->
      <!--                :length="getTotalItem(totalItem)"-->
      <!--                prev-icon="mdi-menu-left"-->
      <!--                next-icon="mdi-menu-right"-->
      <!--            />-->

      <v-col
        cols="12"
        md="12"
        class="pb-0"
        style="display: flex; justify-content: flex-end; padding: 0 12px"
      >
        <div class="text-right mb-1 mt-2">
          {{ showIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="
              () => {
                currentPage--;
              }
            "
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            :disabled="
              requestList.length < limit || currentPage * limit >= totalItem
            "
            small
            class="pagination-btn-right"
            @click="
              () => {
                currentPage++;
              }
            "
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </div>
    <modal-view-file-attachment></modal-view-file-attachment>
  </div>
</template>

<script>
import TokenService from "@/helpers/token";
import moment from "moment";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
import { PRIORITY_SUPPORT } from "@/helpers/constants";
import ModalViewFileAttachment from "@/pages/support/components/ModalViewFileAttachment";
const SupportRepository = RepositoryFactory.get("support");
const ImageRepository = RepositoryFactory.get("image");

export default {
  components: {
    ModalViewFileAttachment,
  },
  data() {
    return {
      currentPage: 1,
      requestList: [],
      statusList: [],
      totalItem: 0,
      limit: 20,
      filterForm: {
        mobile: "",
        startDateTime: moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD"),
        endDateTime: moment()
          .endOf("isoWeek")
          .format("YYYY-MM-DD"),
      },
      file: {},
      stringBase64: "",
      requestSelected: {},
      PRIORITY_SUPPORT,
    };
  },
  async created() {
    if (this.$route.query?.createdAt) {
      this.filterForm.activatedAt = [
        moment(this.$route.query?.createdAt).format("YYYY-MM-DD"),
        moment(this.$route.query?.createdAt).format("YYYY-MM-DD"),
      ];
    }
    this.filterForm.createdName = this.$route.query?.createdName;
    this.filterForm.customerCode = this.$route.query?.nameCode;
    await this.getListSupportV2();
    Bus.$on("search-request-support-list-2", (filterForm) => {
      this.filterForm = filterForm;
      this.currentPage = 1;
      this.getListSupportV2();
    });
    Bus.$on("fetch-table-while-change-tab5", () => {
      this.getListSupportV2();
    });
  },
  beforeDestroy() {
    Bus.$off("search-request-support-list-2");
    Bus.$off("fetch-table-while-change-tab5");
  },
  watch: {
    currentPage: {
      handler() {
        this.getListSupportV2();
      },
    },
  },
  methods: {
    convertDate(chuoiNgay) {
      if (!chuoiNgay) return "_";
      chuoiNgay = chuoiNgay.toString();
      // Lấy năm, tháng và ngày từ chuỗi
      let nam = chuoiNgay.substring(0, 4);
      let thang = chuoiNgay.substring(4, 6);
      let ngay = chuoiNgay.substring(6, 8);

      // Tạo một đối tượng Date
      let ngayThang = new Date(nam, thang - 1, ngay);

      // Lấy ngày, tháng, năm trong định dạng mong muốn
      let ngayMongMuon =
        ngayThang.getDate() +
        "/" +
        (ngayThang.getMonth() + 1) +
        "/" +
        ngayThang.getFullYear();

      return ngayMongMuon;
    },
    renderPriority(value) {
      let priority = _.find(this.PRIORITY_SUPPORT, { value: value });
      return priority?.name || "_";
    },
    async getListSupportV2() {
      const params = {
        "content_id": this.filterForm.content_id || null,
        "ad_id": this.filterForm.ad_id || null,
        "name": this.filterForm.name || null,
        "sender_id": this.filterForm.sender_id || null,
        "start_date": this.filterForm.activatedAt?.length ? this.filterForm.activatedAt[0] : null,
        "end_date": this.filterForm.activatedAt?.length ? this.filterForm.activatedAt[1] : null,
        limit: this.limit,
        page: this.currentPage,
      };
      const loading = this.$loading.show();
      let res = await SupportRepository.getListBituChat(params);
      console.log(res);
      if (res.success) {
        this.requestList = _.get(res, "data", []);
        this.totalItem = _.get(res, "totalItem", 0);
      } else {
        this.requestList = [];
      }
      loading.hide();
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("HH:mm:ss DD/MM/YYYY");
      } else {
        return "";
      }
    },
    showIndex() {
      if (this.requestList.length > 0) {
        let maxIndex =
          this.requestList.length < this.limit
            ? parseInt(this.currentPage - 1) * parseInt(this.limit) +
              this.requestList.length
            : parseInt(this.currentPage) * parseInt(this.limit);
        return this.requestList.length < this.limit
          ? maxIndex - parseInt(this.requestList.length) + 1 + " - " + maxIndex
          : maxIndex - parseInt(this.limit) + 1 + " - " + maxIndex;
      } else {
        return "0 - 0";
      }
    },
  },
};
</script>

<style scoped>
/deep/table tr th {
  text-align: center !important;
  border-bottom: 1px solid #8e8e8e !important;
  height: 30px;
  font-weight: 900 !important;
  padding: 20px 0;
  color: #777777 !important;
  font-size: 14px !important;
  padding: 15px !important;
  position: sticky;
  top: 0;
  background-color: #fff !important;
}

/deep/table tr th.content {
  width: 300px;
  text-wrap: wrap;
}
/deep/table tr th.time {
  width: 100px;
  text-wrap: wrap;
}

/deep/table tr td {
  border-bottom: 1px solid #8e8e8e !important;
  height: 35px !important;
  padding: 15px !important;
  font-weight: 500 !important;
  color: #777777 !important;
  font-size: 12px !important;
}

.th_mobile {
  width: 110px;
}

.th_status {
  width: 130px;
}

.td_request {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 250px;
}

.td_urgent {
  max-width: 150px !important;
  min-width: 100px !important;
}
.file-icon {
  transform: rotate(-45deg);
}
</style>
